import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Conversion } from '@/components/pages/edit-campaign/form-elements/conversion';
import { Cpa } from '@/components/pages/edit-campaign/form-elements/cpa';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Tooltip } from '@/components/ui/tooltip';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

export function IndeedForm() {
  const { campaign, hookForm, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;
  const { control } = hookForm;
  const endAtTypeOptions = useEndAtTypeOptions();

  return (
    <>
      <Dates />

      <Controller
        control={control}
        name="end_at_type"
        render={({ field }) => (
          <RadioGroup
            onValueChange={field.onChange}
            value={field.value}
            className="flex flex-col gap-6"
            disabled={isCompleted || isReadonly}
          >
            {endAtTypeOptions.map(option => (
              <Tooltip
                key={option.value}
                content={option.description}
                className="w-80"
              >
                <div className="flex w-fit items-center space-x-2">
                  <RadioGroupItem value={option.value} id={option.value} />
                  <Label htmlFor={option.value}>{option.label}</Label>
                </div>
              </Tooltip>
            ))}
          </RadioGroup>
        )}
      />

      <Budget />
      <TargetBudget />
      <Cpa />
      <Conversion />
    </>
  );
}

function useEndAtTypeOptions() {
  const intl = useIntl();

  return [
    {
      value: 'fixed',
      label: intl.formatMessage({ defaultMessage: 'Fixed end date' }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date and also ensures that the campaign doesn’t spend beyond the specified date even if there is budget remaining.',
      }),
    },
    {
      value: 'target',
      label: intl.formatMessage({ defaultMessage: 'Target end date' }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date, but the campaign may spend past this date if the campaign still has budget remaining.',
      }),
    },
  ];
}
